import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBrochureContainer } from 'shared/containers/NewbuildingBrochure';

import { NewbuildingSpecifications as NewbuildingSpecificationsComponent } from '../../components/NewbuildingSpecifications';
import { getNewbuildingSpecifications, getNewbuildingDeveloper, getNewbuildingStatus } from '../../selectors/newObject';

export const NewbuildingSpecifications = () => {
  const specifications = useSelector(getNewbuildingSpecifications);
  const status = useSelector(getNewbuildingStatus);
  const developer = useSelector(getNewbuildingDeveloper);

  return (
    <NewbuildingSpecificationsComponent
      brochure={<NewbuildingBrochureContainer />}
      specifications={specifications}
      developer={developer}
      status={status}
    />
  );
};
